import React from "react";
import { Link, LinkBase } from "@quintype/components";
import PropTypes from "prop-types";

import { getTextColor, generateNavigateSlug } from "../../../utils/utils";
import { SvgIconHandler } from "../../../../components/atoms/SvgIconHandler";

import "./load-more.m.css";

export const LoadmoreButton = ({
  config = {},
  collection,
  template = "SubsequentLoadCount",
  onClick,
  navigate,
  qtConfig,
  sectionSwitch = false,
  isBtnWithArrow,
}) => {
  const { showButton = true, buttonText = "Read More", theme = "", customUrlPath = "" } = config;
  if (!showButton) return null;

  const textColor = getTextColor(theme);
  const slug = customUrlPath ? `/${customUrlPath}` : generateNavigateSlug(collection, { ...qtConfig, ...config });

  if (sectionSwitch) {
    if (isBtnWithArrow) {
      return (
        <div className="load-more-with-arrow" style={{ cursor: "pointer" }} onClick={() => sectionSwitch()}>
          {buttonText}
          {/* <SvgIconHandler type="read-more-arrow" width="18" height="18" /> */}
        </div>
      );
    } else {
      return (
        <div
          className="arr--button"
          styleName={`button ${textColor} default`}
          onClick={() => sectionSwitch()}
          data-test-id="load-more"
        >
          {buttonText}
        </div>
      );
    }
  }

  if (isBtnWithArrow) {
    return (
      <Link className="load-more-with-arrow" href={slug} disableAjaxLinks={true}>
        {buttonText}
        {/* <SvgIconHandler type="read-more-arrow" width="18" height="18" /> */}
      </Link>
    );
  }

  return template === "SubsequentLoadCount" ? (
    <div className="arr--button" styleName={`button ${textColor} default`} onClick={onClick} data-test-id="load-more">
      {buttonText}
    </div>
  ) : (
    <LinkBase href={slug} navigateTo={navigate} data-test-id="load-more" aria-label="load-more" disableAjaxLinks={true}>
      <div className="arr--button" styleName={`button ${textColor} default`}>
        {buttonText}
      </div>
    </LinkBase>
  );
};

LoadmoreButton.propTypes = {
  collection: PropTypes.object,
  template: PropTypes.string,
  config: PropTypes.object,
  onClick: PropTypes.func,
  navigate: PropTypes.func,
  sectionSwitch: PropTypes.func,
  qtConfig: PropTypes.object,
};
